import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    CR_SUPPLIER,
    CR_DELIVERY_ORDER,
    CR_ASSIGNED_USER,
    CR_STATUS,
    CR_LIST,
    CR_ASSIGN,
    CR_LIST_UNASSIGNED,
    CR_LIST_USER,
    CR_VERIFY
} from "../../actions";

import {
    CRSupplierSuccess,
    CRSupplierError,
    CRDeliveryOrderSuccess,
    CRDeliveryOrderError,
    CRAssignedUserSuccess,
    CRAssignedUserError,
    CRStatusSuccess,
    CRStatusError,
    CRListSuccess,
    CRListError,
    CRAssignSuccess,
    CRAssignError,
    CRListUnassignedSuccess,
    CRListUnassignedError,
    CRListUserSuccess,
    CRListUserError,
    CRVerifySuccess,
    CRVerifyError
} from '../../actions';


export function* watchCRSupplier() {
    yield takeEvery(CR_SUPPLIER, onCRSupplier);
}

export function* watchCRDeliveryOrder() {
    yield takeEvery(CR_DELIVERY_ORDER, onCRDeliveryOrder);
}

export function* watchCRAssignedUser() {
    yield takeEvery(CR_ASSIGNED_USER, onCRAssignedUser);
}

export function* watchCRStatus() {
    yield takeEvery(CR_STATUS, onCRStatus);
}

export function* watchCRList() {
    yield takeEvery(CR_LIST, onCRList);
}

export function* watchCRAssign() {
    yield takeEvery(CR_ASSIGN, onCRAssign);
}

export function* watchCRListUnassigned() {
    yield takeEvery(CR_LIST_UNASSIGNED, onCRListUnassigned);
}

export function* watchCRListUser() {
    yield takeEvery(CR_LIST_USER, onCRListUser);
}

export function* watchCRVerify() {
    yield takeEvery(CR_VERIFY, onCRVerify);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onCRSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRAssignedUserAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/assigneduser', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/status', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onCRAssignAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/assign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRListUnassignedAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/listunassigned', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRListUserAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/listuser', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onCRVerifyAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'cashreceipt/verify', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


function* onCRSupplier(data) {
    try {
        const response = yield call(onCRSupplierAsync, data.payload);
        yield put(CRSupplierSuccess(response.data));
    } catch (error) {
        yield put(CRSupplierError(error));
    }
}

function* onCRDeliveryOrder(data) {
    try {
        const response = yield call(onCRDeliveryOrderAsync, data.payload);
        yield put(CRDeliveryOrderSuccess(response.data));yg
    } catch (error) {
        yield put(CRDeliveryOrderError(error));
    }
}

function* onCRAssignedUser(data) {
    try {
        const response = yield call(onCRAssignedUserAsync, data.payload);
        yield put(CRAssignedUserSuccess(response.data)); yg
    } catch (error) {
        yield put(CRAssignedUserError(error));
    }
}

function* onCRStatus(data) {
    try {
        const response = yield call(onCRStatusAsync, data.payload);
        yield put(CRStatusSuccess(response.data)); yg
    } catch (error) {
        yield put(CRStatusError(error));
    }
}

function* onCRList(data) {
    try {
        const response = yield call(onCRListAsync, data.payload);
        yield put(CRListSuccess(response.data));
    } catch (error) {
        yield put(CRListError(error));
    }
}

function* onCRAssign(data) {
    try {
        const response = yield call(onCRAssignAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(CRAssignSuccess(response.data));
    } catch (error) {
        yield put(CRAssignError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onCRListUnassigned(data) {
    try {
        const response = yield call(onCRListUnassignedAsync, data.payload);
        yield put(CRListUnassignedSuccess(response.data)); yg
    } catch (error) {
        yield put(CRListUnassignedError(error));
    }
}

function* onCRListUser(data) {
    try {
        const response = yield call(onCRListUserAsync, data.payload);
        yield put(CRListUserSuccess(response.data)); yg
    } catch (error) {
        yield put(CRListUserError(error));
    }
}

function* onCRVerify(data) {
    try {
        const response = yield call(onCRVerifyAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(CRVerifySuccess(response.data));
    } catch (error) {
        yield put(CRVerifyError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchCRSupplier),
        fork(watchCRDeliveryOrder),
        fork(watchCRAssignedUser),
        fork(watchCRStatus),
        fork(watchCRList),
        fork(watchCRAssign),
        fork(watchCRListUnassigned),
        fork(watchCRListUser),
        fork(watchCRVerify),
    ]);
}